import { render, staticRenderFns } from "./SubjectView.vue?vue&type=template&id=09584f1e&scoped=true"
import script from "./SubjectView.vue?vue&type=script&lang=js"
export * from "./SubjectView.vue?vue&type=script&lang=js"
import style0 from "./SubjectView.vue?vue&type=style&index=0&id=09584f1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09584f1e",
  null
  
)

export default component.exports